<template>
  <div class="address">
    <div class="address_nav">
      <navbar
        title="选择收货地址"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <van-row class="box">
      <van-col span="24" class="show_address">
        <span class="icon">
          <img src="../../../assets/accountAgent/order/no_select.png" alt="" />
        </span>
        <p class="name">小猫咪<span>13099998866</span></p>
        <p class="site">浙江省 杭州市 江干区 财富金融中心西楼3楼</p>
      </van-col>
      <van-col span="24" class="show_address">
        <span class="icon">
          <img src="../../../assets/accountAgent/order/selected.png" alt="" />
        </span>
        <p class="name">小猫咪<span>13099998866</span></p>
        <p class="site">
          浙江省 杭州市 江干区 财富金融中心西楼3楼浙江省 杭州市 江干区
          财富金融中心西楼3楼
        </p>
      </van-col>
    </van-row>
    <van-row class="address_footer">
      <van-col span="24">
        <btn
          :btntext="'确定'"
          :btnwidth="'100%'"
          :height="'5rem'"
          :bgcolor="'#F9591B'"
          :borderradius="'2.5rem'"
          :btncolor="'#fff'"
          :fontsize="'1.8rem'"
          :fontweight="500"
          @btnClick="toContinue"
        />
      </van-col>
    </van-row>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
    };
  },
  created() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    toContinue() {
      // sessionStorage.setItem("userAddress", JSON.stringify(item));
      this.goBack();
    },
  },
};
</script>
<style lang="less" scoped>
.address {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .address_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 6.4rem;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .show_address {
      min-height: 7.2rem;
      padding: 1.2rem 4.4rem 1.2rem 1.2rem;
      background: #fff;
      border-radius: 0.6rem;
      margin-bottom: 1rem;
      text-align: left;
      position: relative;

      .icon {
        width: 4.4rem;
        min-height: 7.2rem;
        height: 100%;
        position: absolute;
        right: 0;
        top: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 1.2rem;

        img {
          width: 2rem;
        }
      }

      .name {
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        height: 2.2rem;
        line-height: 2.2rem;
        margin-bottom: 0.6rem;

        span {
          color: #999;
          font-size: 1.4rem;
          font-weight: 400;
          margin-left: 1.2rem;
        }
      }

      .site {
        color: #999;
        font-size: 1.4rem;
        line-height: 2.2rem;
      }
    }
  }

  .address_footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 0 1.2rem 0.4rem;
    box-sizing: border-box;
  }
}
</style>


